import React from 'react';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const wrapRootElement = ({ element }) => (
  <GoogleReCaptchaProvider
    reCaptchaKey="6LfTlGorAAAAAPdIK3VBvuKXoXK6MLfq5ttiYFVW"
    scriptProps={{
      async: true,
      defer: true,
      appendTo: "head",
    }}
  >
    {element}
  </GoogleReCaptchaProvider>
);
